import $ from 'jquery';

const validators = {
    filesize: {
        isValid: function (_value, element, _param) {
            return !element.files
                || !element.files[0]
                || !element.files[0].size
                || element.files[0].size <= 28000000;
        },
        unpack: function (options) {
            options.rules['filesize'] = true;
            options.messages['filesize'] = options.message;
        }
    }
};

function setupFileUpload(parentSelector) {
    let elements = $('[data-file-upload]');

    if (parentSelector) {
        elements = $(parentSelector).find('[data-file-upload]');
    }

    elements.each(bindFileUpload);
}

function bindFileUpload(_i, element) {
    let input = $(element).find('[data-file-upload-input]');
    let photoSection = $(element).find('[data-file-upload-photo-section]');
    let photoButton = $(element).find('[data-file-upload-photo-button]');
    let fileSection = $(element).find('[data-file-upload-file-section]');
    let fileButton = $(element).find('[data-file-upload-file-button]');
    let previewSection = $(element).find('[data-file-upload-preview-section]');
    let previewName = $(element).find('[data-file-upload-preview-name]');
    let previewImage = $(element).find('[data-file-upload-preview-image]');
    let previewDelete = $(element).find('[data-file-upload-preview-delete]');
    let photoAvailable = 'capture' in input[0];

    photoSection.toggle(photoAvailable);

    fileButton.on('click', _ => {
        input.attr('capture', null);
        input.trigger('click');
    });

    photoButton.on('click', _ => {
        input.attr('capture', true);
        input.trigger('click');
    });

    previewDelete.on('click', _ => {
        input.val('');
        input.trigger('change');
    });

    input.on('change', _ => {
        let file = input[0].files[0];
        let showPreview = !!file;

        fileSection.toggle(!showPreview);
        photoSection.toggle(!showPreview && photoAvailable);

        previewImage.show();
        previewImage.attr('src', file ? URL.createObjectURL(file) : '');
        previewName.text(file?.name);
        previewSection.toggle(showPreview);
        input.trigger('blur');
    });

    previewImage.on('error', _ => {
        previewImage.hide();
    });

    $('body').on('dragenter dragover drop', x => {
        x.stopPropagation();
        x.preventDefault();
    });

    let dragCount = 0;

    fileSection
        .on('dragenter', _ => {
            if (dragCount++ == 0) {
                fileSection.addClass('dragover');
            }
        })
        .on('dragleave drop', _ => {
            if (--dragCount <= 0) {
                fileSection.removeClass('dragover');
                dragCount = 0;
            }
        })
        .on('drop', x => {
            input[0].files = x.originalEvent.dataTransfer.files;
            input.trigger('change');
        });
}

export { validators, setupFileUpload };